<template>
  <v-autocomplete
    :items="graus"
    :label="i18n(label)"
    :outlined="outlined"
    :readonly="readonly"
    :autofocus="autofocus"
    :clearable="clearable"
    :prepend-inner-icon="icon"
    :hide-details="hideDetails"
    v-model="grau"
  />
</template>

<script>
const onlyNumber = (str) => isNaN(str) ? null : Number(str)
export default {
  props: {
    icon: {},
    value: {},
    label: { default: 'field.grau' },
    outlined: { default: false },
    readonly: { default: false },
    clearable: { default: false },
    autofocus: {},
    hideDetails: { default: true }
  },

  data () {
    return {
      grau: onlyNumber(this.value),
      graus: [
        { value: 1, text: 'Quadro de Sócios' },
        { value: 2, text: 'Corpo Instrutivo' },
        { value: 3, text: 'Corpo do Conselho' },
        { value: 4, text: 'Quadro de Mestres' }
      ]
    }
  },

  watch: {
    grau () {
      const grau = onlyNumber(this.grau)
      const changed = grau !== onlyNumber(this.value)
      if (changed) this.$emit('input', grau)
    },

    value () {
      const value = onlyNumber(this.value)
      const changed = value !== onlyNumber(this.grau)
      if (changed) this.grau = value
    }
  }
}
</script>
